module.exports = __webpack_public_path__ + "static/media/crown.49739d94.svg";